import Masonry from 'masonry-layout';

/**
 * Returns a callback to initialize the masonry behavior.
 * @param {Element} component
 * @return {Function} A callback function
 */
const handleInit = (component) => () => {
    const colWidth = $(component).attr('data-col-width');
    const grid = $(component).find('.grid').get(0);

    const masonry = new Masonry(grid, {
        itemSelector: '.grid__col',
        percentPosition: true,
        columnWidth: `.grid__col--${colWidth}`,
    });

    // specifically set internal ref to masonry instance as data(),
    // not as data attribute!
    $(component).data('masonry', masonry);
};

export default handleInit;



// WEBPACK FOOTER //
// ./src/scripts/components/masonry/handleInit.js